import styles from "./App.module.css";
import { About } from "./components/About/About";
import DetailedAboutUs from "./components/About/DetailedAboutUs";
import { Contact } from "./components/Contact/Contact";
import { Experience } from "./components/Experience/Experience";
import { Hero } from "./components/Hero/Hero";
import { Navbar } from "./components/Navbar/Navbar";
import ProductDetails from "./components/Projects/ProductDetails";
import { Projects } from "./components/Projects/Projects";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import TeamCarousel from "./components/Team/TeamCarousel";
import Team from "./components/Team/Team";
import HimalyanDiamond from "./components/Products/HimalyanDiamond";
import GopalanDiamond from "./components/Products/GopalanDiamons";
import KuberDiamond from "./components/Products/KuberDiamond";
import AadarshGold from "./components/Products/AadarshGold";
import GoshalaGold from "./components/Products/GoshalaGold";
import DairyGold from "./components/Products/DairyGold";
import DaivikMix from "./components/Products/DaivikMix";
import KuberMix from "./components/Products/KuberMix";
import { useEffect } from "react";
import Gallery from "./components/Gallery/Gallery";
import ScrollToTop from "./ScrollOnTop";

const googleTranslateElementInit = () => {
  if (window.google && window.google.translate) {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        includedLanguages: "en,hi",
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        autoDisplay: false,
      },
      "google_translate_element"
    );
  } else {
    console.error("Google Translate API not available.");
  }
};

function App() {
  useEffect(() => {
    window.googleTranslateElementInit = googleTranslateElementInit;

    const addScript = document.createElement("script");
    addScript.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    addScript.async = true;

    addScript.onload = () => {
      // Poll for google.translate to be available before calling the init function
      const intervalId = setInterval(() => {
        if (window.google && window.google.translate) {
          clearInterval(intervalId);
          googleTranslateElementInit();
        }
      }, 100); // Check every 100ms
    };

    addScript.onerror = () => {
      console.error("Failed to load the Google Translate script.");
    };

    document.body.appendChild(addScript);

    return () => {
      // Clean up script if component is unmounted
      document.body.removeChild(addScript);
    };
  }, []);

  return (
    <>
      <div className={styles.App}>
        {/* <Navbar />
      <Hero />
      <About />
      <Projects />
      <Contact /> */}
        {/* <BrowserRouter> */}
        <Routes>
          <Route
            path="/"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <Hero />
                <About />
                <Gallery />
                <Team />
                <Projects />
                <Team isTestemonials={true} />
                <Contact />
              </>
            }
          />
          <Route
            path="/gallery"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <Hero />
                <Gallery />
                <Contact />
              </>
            }
          />
          <Route
            path="/products/Himalya-diamond-pellets"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <HimalyanDiamond />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/Gopalan-diamond-pellets"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <GopalanDiamond />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/Kuber-diamond-pellets"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <KuberDiamond />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/Adarsh-gold-pellets"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <AadarshGold />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/Gaushala-gold-pellets"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <GoshalaGold />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/Dairy-gold-pellets"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <DairyGold />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/Daivik-mix"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <DaivikMix />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/Kuber-mix"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <KuberMix />
                <Contact />
              </>
            }
          />

          <Route
            path="/products/:group/:productId"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <ProductDetails />
                <Contact />
              </>
            }
          />

          <Route
            path="/about"
            element={
              <>
                <ScrollToTop />
                <Navbar />
                <DetailedAboutUs />
                <Contact />
              </>
            }
          />
        </Routes>
        {/* </BrowserRouter> */}
      </div>
    </>
  );
}

export default App;
